/**
 * Purpose:
 *   Tailwind CSS class constants for the Avatar component.
 *
 * Notes:
 *   - Organized by component section (container, avatar circle, dropdown)
 *   - Uses project color tokens from Tailwind config
 */

// Main container with dropdown wrapper
export const AVATAR_CONTAINER = `
  relative
`;

// Clickable avatar button wrapper
export const AVATAR_BUTTON = `
  flex gap-3 items-center cursor-pointer
  rounded-lg px-4 py-2
  hover:bg-white/10 transition-colors
`;

// User name text (hidden on mobile)
export const AVATAR_NAME = `
  text-white font-medium hidden desktop:block
`;

// Avatar circle with initials
export const AVATAR_CIRCLE = `
  flex justify-center items-center
  bg-blue-0 rounded-full overflow-hidden
  text-sm font-medium text-green-400
`;

// Dropdown container base styles
export const DROPDOWN_CONTAINER = `
  absolute right-0 top-full mt-2
  bg-white border border-base-100
  rounded-lg shadow-lg
  min-w-[160px] overflow-hidden
  transition-all duration-200 ease-out
  origin-top-right z-50
`;

// Dropdown states for animation
export const DROPDOWN_OPEN = `
  opacity-100 scale-100 pointer-events-auto
`;

export const DROPDOWN_CLOSED = `
  opacity-0 scale-95 pointer-events-none
`;

// Dropdown menu item
export const DROPDOWN_ITEM = `
  w-full px-4 py-2.5 text-left text-sm
  text-neutral-500 hover:bg-base-0
  transition-colors flex items-center gap-2
  disabled:opacity-50 disabled:cursor-not-allowed
`;

// Dropdown divider
export const DROPDOWN_DIVIDER = `
  border-t border-base-100 my-1
`;

// Dropdown item active state
export const DROPDOWN_ITEM_ACTIVE = `
  bg-base-0 font-medium
`;

// Icon neutral color
export const ICON_NEUTRAL = `
  text-neutral-400
`;

